import { jackpotApi as api } from './emptyJackpotApi';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    jackpotControllerGetLatestDrawnJackpotsByUserId: build.query<
      JackpotControllerGetLatestDrawnJackpotsByUserIdApiResponse,
      JackpotControllerGetLatestDrawnJackpotsByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/jackpot-api/latest-drawn-jackpots`,
        params: { intervalMinutes: queryArg.intervalMinutes },
      }),
    }),
    jackpotControllerGetLatestWinners: build.query<
      JackpotControllerGetLatestWinnersApiResponse,
      JackpotControllerGetLatestWinnersApiArg
    >({
      query: (queryArg) => ({
        url: `/jackpot-api/latest-winners`,
        params: { limit: queryArg.limit, hours: queryArg.hours },
      }),
    }),
    jackpotControllerGetActiveJackpots: build.query<
      JackpotControllerGetActiveJackpotsApiResponse,
      JackpotControllerGetActiveJackpotsApiArg
    >({
      query: () => ({ url: `/jackpot-api/active-jackpots` }),
    }),
    jackpotControllerGetMyActiveJackpots: build.query<
      JackpotControllerGetMyActiveJackpotsApiResponse,
      JackpotControllerGetMyActiveJackpotsApiArg
    >({
      query: () => ({ url: `/jackpot-api/my-active-jackpots` }),
    }),
    jackpotControllerGetDrawnUserJackpots: build.query<
      JackpotControllerGetDrawnUserJackpotsApiResponse,
      JackpotControllerGetDrawnUserJackpotsApiArg
    >({
      query: (queryArg) => ({
        url: `/jackpot-api/my-drawn-jackpots`,
        params: { take: queryArg.take, skip: queryArg.skip },
      }),
    }),
    jackpotControllerGetUserWinsFromJackpots: build.query<
      JackpotControllerGetUserWinsFromJackpotsApiResponse,
      JackpotControllerGetUserWinsFromJackpotsApiArg
    >({
      query: () => ({ url: `/jackpot-api/my-jackpot-wins` }),
    }),
    jackpotControllerGetJackpotHistory: build.query<
      JackpotControllerGetJackpotHistoryApiResponse,
      JackpotControllerGetJackpotHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/jackpot-api/jackpot/history`,
        params: {
          slug: queryArg.slug,
          take: queryArg.take,
          skip: queryArg.skip,
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
        },
      }),
    }),
    jackpotControllerGetJackpotWinners: build.query<
      JackpotControllerGetJackpotWinnersApiResponse,
      JackpotControllerGetJackpotWinnersApiArg
    >({
      query: (queryArg) => ({
        url: `/jackpot-api/jackpot/${queryArg.jackpotId}/winners`,
      }),
    }),
    jackpotControllerGetJackpotMetadata: build.query<
      JackpotControllerGetJackpotMetadataApiResponse,
      JackpotControllerGetJackpotMetadataApiArg
    >({
      query: (queryArg) => ({
        url: `/jackpot-api/jackpot-metadata`,
        params: { jackpotSlug: queryArg.jackpotSlug },
      }),
    }),
    jackpotControllerGetJackpotsMetadata: build.query<
      JackpotControllerGetJackpotsMetadataApiResponse,
      JackpotControllerGetJackpotsMetadataApiArg
    >({
      query: (queryArg) => ({
        url: `/jackpot-api/jackpots-metadata`,
        params: { jackpotSlugs: queryArg.jackpotSlugs },
      }),
    }),
    jackpotControllerGetJackpotStats: build.query<
      JackpotControllerGetJackpotStatsApiResponse,
      JackpotControllerGetJackpotStatsApiArg
    >({
      query: () => ({ url: `/jackpot-api/jackpot-stats` }),
    }),
    jackpotControllerGetMyWinTickets: build.query<
      JackpotControllerGetMyWinTicketsApiResponse,
      JackpotControllerGetMyWinTicketsApiArg
    >({
      query: (queryArg) => ({
        url: `/jackpot-api/my-tickets-in-jackpot/${queryArg.jackpotId}`,
      }),
    }),
    jackpotControllerGetJackpotWinInfo: build.query<
      JackpotControllerGetJackpotWinInfoApiResponse,
      JackpotControllerGetJackpotWinInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/jackpot-api/jackpot-win-info/${queryArg.jackpotId}`,
      }),
    }),
    jackpotControllerGetJackpotWinTicketIndices: build.query<
      JackpotControllerGetJackpotWinTicketIndicesApiResponse,
      JackpotControllerGetJackpotWinTicketIndicesApiArg
    >({
      query: (queryArg) => ({
        url: `/jackpot-api/jackpot-win-ticket-indices/${queryArg.jackpotId}`,
      }),
    }),
    jackpotControllerGetUserTurnover: build.query<
      JackpotControllerGetUserTurnoverApiResponse,
      JackpotControllerGetUserTurnoverApiArg
    >({
      query: (queryArg) => ({
        url: `/jackpot-api/top-players-by`,
        params: { type: queryArg['type'] },
      }),
    }),
    jackpotControllerGetReserves: build.query<
      JackpotControllerGetReservesApiResponse,
      JackpotControllerGetReservesApiArg
    >({
      query: () => ({ url: `/jackpot-api/active-reserve-jackpots` }),
    }),
    jackpotControllerGetDrawPlatinumJackpotTimeInUtc: build.query<
      JackpotControllerGetDrawPlatinumJackpotTimeInUtcApiResponse,
      JackpotControllerGetDrawPlatinumJackpotTimeInUtcApiArg
    >({
      query: () => ({ url: `/jackpot-api/platinum-jackpot-draw-time` }),
    }),
    healthControllerPing: build.query<
      HealthControllerPingApiResponse,
      HealthControllerPingApiArg
    >({
      query: () => ({ url: `/jackpot-api/health` }),
    }),
    metricsControllerGetMetrics: build.query<
      MetricsControllerGetMetricsApiResponse,
      MetricsControllerGetMetricsApiArg
    >({
      query: () => ({ url: `/jackpot-api/metrics` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as jackpotApi };
export type JackpotControllerGetLatestDrawnJackpotsByUserIdApiResponse =
  /** status 200  */ LatestDrawnJackpotsListOutputDto;
export type JackpotControllerGetLatestDrawnJackpotsByUserIdApiArg = {
  intervalMinutes: number;
};
export type JackpotControllerGetLatestWinnersApiResponse =
  /** status 200  */ LatestWinnersListDto;
export type JackpotControllerGetLatestWinnersApiArg = {
  /** Number of top winners to retrieve (1-100) */
  limit?: number;
  /** Time period in hours to look back for winners data (1-24) */
  hours?: number;
};
export type JackpotControllerGetActiveJackpotsApiResponse =
  /** status 200  */ ActiveJackpotDto[];
export type JackpotControllerGetActiveJackpotsApiArg = void;
export type JackpotControllerGetMyActiveJackpotsApiResponse =
  /** status 200  */ ActiveJackpotDto[];
export type JackpotControllerGetMyActiveJackpotsApiArg = void;
export type JackpotControllerGetDrawnUserJackpotsApiResponse =
  /** status 200  */ DrawnUserJackpotListDto;
export type JackpotControllerGetDrawnUserJackpotsApiArg = {
  take?: number;
  skip?: number;
};
export type JackpotControllerGetUserWinsFromJackpotsApiResponse = /** status 200  */ {
  todayWins?: string;
  monthWins?: string;
  totalWins?: string;
};
export type JackpotControllerGetUserWinsFromJackpotsApiArg = void;
export type JackpotControllerGetJackpotHistoryApiResponse =
  /** status 200  */ JackpotHistoryListDto;
export type JackpotControllerGetJackpotHistoryApiArg = {
  slug:
    | 'OpenQual-A'
    | 'OpenQual-B'
    | 'OpenQual-C'
    | 'ClosedQual-A1'
    | 'ClosedQual-A2'
    | 'ClosedQual-A3'
    | 'ClosedQual-B1'
    | 'ClosedQual-B2'
    | 'ClosedQual-B3'
    | 'ClosedQual-C1'
    | 'ClosedQual-C2'
    | 'ClosedQual-C3'
    | 'Final1'
    | 'ActivePlayers'
    | 'Partner'
    | 'Platinum';
  take?: number;
  skip?: number;
  startDate?: string;
  endDate?: string;
};
export type JackpotControllerGetJackpotWinnersApiResponse =
  /** status 200  */ JackpotWinnerDto[];
export type JackpotControllerGetJackpotWinnersApiArg = {
  jackpotId: string;
};
export type JackpotControllerGetJackpotMetadataApiResponse =
  /** status 200  */ JackpotMetadataDto;
export type JackpotControllerGetJackpotMetadataApiArg = {
  jackpotSlug:
    | 'OpenQual-A'
    | 'OpenQual-B'
    | 'OpenQual-C'
    | 'ClosedQual-A1'
    | 'ClosedQual-A2'
    | 'ClosedQual-A3'
    | 'ClosedQual-B1'
    | 'ClosedQual-B2'
    | 'ClosedQual-B3'
    | 'ClosedQual-C1'
    | 'ClosedQual-C2'
    | 'ClosedQual-C3'
    | 'Final1'
    | 'ActivePlayers'
    | 'Partner'
    | 'Platinum';
};
export type JackpotControllerGetJackpotsMetadataApiResponse =
  /** status 200  */ JackpotsMetadataDto;
export type JackpotControllerGetJackpotsMetadataApiArg = {
  jackpotSlugs: (
    | 'OpenQual-A'
    | 'OpenQual-B'
    | 'OpenQual-C'
    | 'ClosedQual-A1'
    | 'ClosedQual-A2'
    | 'ClosedQual-A3'
    | 'ClosedQual-B1'
    | 'ClosedQual-B2'
    | 'ClosedQual-B3'
    | 'ClosedQual-C1'
    | 'ClosedQual-C2'
    | 'ClosedQual-C3'
    | 'Final1'
    | 'ActivePlayers'
    | 'Partner'
    | 'Platinum'
  )[];
};
export type JackpotControllerGetJackpotStatsApiResponse =
  /** status 200  */ JackpotStatsDto;
export type JackpotControllerGetJackpotStatsApiArg = void;
export type JackpotControllerGetMyWinTicketsApiResponse = unknown;
export type JackpotControllerGetMyWinTicketsApiArg = {
  jackpotId: string;
};
export type JackpotControllerGetJackpotWinInfoApiResponse = unknown;
export type JackpotControllerGetJackpotWinInfoApiArg = {
  jackpotId: string;
};
export type JackpotControllerGetJackpotWinTicketIndicesApiResponse = unknown;
export type JackpotControllerGetJackpotWinTicketIndicesApiArg = {
  jackpotId: string;
};
export type JackpotControllerGetUserTurnoverApiResponse =
  /** status 200  */ PlayersTopListDto;
export type JackpotControllerGetUserTurnoverApiArg = {
  type: 'turnover' | 'referral';
};
export type JackpotControllerGetReservesApiResponse = /** status 200  */ ReservesDto;
export type JackpotControllerGetReservesApiArg = void;
export type JackpotControllerGetDrawPlatinumJackpotTimeInUtcApiResponse =
  /** status 200  */ PlatinumJackpotDrawTimeOutputDto;
export type JackpotControllerGetDrawPlatinumJackpotTimeInUtcApiArg = void;
export type HealthControllerPingApiResponse = /** status 200  */ string;
export type HealthControllerPingApiArg = void;
export type MetricsControllerGetMetricsApiResponse = unknown;
export type MetricsControllerGetMetricsApiArg = void;
export type LatestDrawnJackpotsListRecordOutputDto = {
  jackpotSlug:
    | 'OpenQual-A'
    | 'OpenQual-B'
    | 'OpenQual-C'
    | 'ClosedQual-A1'
    | 'ClosedQual-A2'
    | 'ClosedQual-A3'
    | 'ClosedQual-B1'
    | 'ClosedQual-B2'
    | 'ClosedQual-B3'
    | 'ClosedQual-C1'
    | 'ClosedQual-C2'
    | 'ClosedQual-C3'
    | 'Final1'
    | 'ActivePlayers'
    | 'Partner'
    | 'Platinum';
  winAmount: string;
};
export type LatestDrawnJackpotsListOutputDto = {
  jackpots: LatestDrawnJackpotsListRecordOutputDto[];
};
export type LatestWinnersRecordDto = {
  userDisplayNumber: string;
  jackpotSlug: string;
  prizeMoney: string;
};
export type LatestWinnersListDto = {
  latestWinners: LatestWinnersRecordDto[];
};
export type ActiveJackpotDto = {
  id: string;
  slug:
    | 'OpenQual-A'
    | 'OpenQual-B'
    | 'OpenQual-C'
    | 'ClosedQual-A1'
    | 'ClosedQual-A2'
    | 'ClosedQual-A3'
    | 'ClosedQual-B1'
    | 'ClosedQual-B2'
    | 'ClosedQual-B3'
    | 'ClosedQual-C1'
    | 'ClosedQual-C2'
    | 'ClosedQual-C3'
    | 'Final1'
    | 'ActivePlayers'
    | 'Partner'
    | 'Platinum';
  drawAmount: string;
  ticketsCount: number;
  distributedTicketsCount: number;
  myTicketsCount: number;
  seedHash: string;
  serialNumber: number;
};
export type RevealedSeedDto = {
  hash: string;
  localSeed: string;
};
export type JackpotWinTicketsInfoDto = {
  count: number;
  jackpotSlug:
    | 'OpenQual-A'
    | 'OpenQual-B'
    | 'OpenQual-C'
    | 'ClosedQual-A1'
    | 'ClosedQual-A2'
    | 'ClosedQual-A3'
    | 'ClosedQual-B1'
    | 'ClosedQual-B2'
    | 'ClosedQual-B3'
    | 'ClosedQual-C1'
    | 'ClosedQual-C2'
    | 'ClosedQual-C3'
    | 'Final1'
    | 'ActivePlayers'
    | 'Partner'
    | 'Platinum';
  jackpotDrawAmount: string;
  jackpotTicketsCount: number;
};
export type JackpotWinResultDto = {
  winAmount: string;
  winTickets: JackpotWinTicketsInfoDto[];
};
export type DrawnUserJackpotDto = {
  id: string;
  slug:
    | 'OpenQual-A'
    | 'OpenQual-B'
    | 'OpenQual-C'
    | 'ClosedQual-A1'
    | 'ClosedQual-A2'
    | 'ClosedQual-A3'
    | 'ClosedQual-B1'
    | 'ClosedQual-B2'
    | 'ClosedQual-B3'
    | 'ClosedQual-C1'
    | 'ClosedQual-C2'
    | 'ClosedQual-C3'
    | 'Final1'
    | 'ActivePlayers'
    | 'Partner'
    | 'Platinum';
  drawnAt: string;
  drawAmount: string;
  ticketsCount: number;
  myTicketsCount: number;
  seed: RevealedSeedDto;
  result: JackpotWinResultDto;
  winPlaces: number[];
};
export type DrawnUserJackpotListDto = {
  count: number;
  jackpots: DrawnUserJackpotDto[];
};
export type JackpotHistoryRecordDto = {
  id: string;
  slug:
    | 'OpenQual-A'
    | 'OpenQual-B'
    | 'OpenQual-C'
    | 'ClosedQual-A1'
    | 'ClosedQual-A2'
    | 'ClosedQual-A3'
    | 'ClosedQual-B1'
    | 'ClosedQual-B2'
    | 'ClosedQual-B3'
    | 'ClosedQual-C1'
    | 'ClosedQual-C2'
    | 'ClosedQual-C3'
    | 'Final1'
    | 'ActivePlayers'
    | 'Partner'
    | 'Platinum';
  drawnAt: string;
  seed: RevealedSeedDto;
};
export type JackpotHistoryListDto = {
  count: number;
  results: JackpotHistoryRecordDto[];
};
export type JackpotWinnerDto = {
  id: string;
  userDisplayNumber: number;
  winResult: JackpotWinResultDto;
};
export type JackpotMetadataTicketDto = {
  count: number;
  jackpotSlug:
    | 'OpenQual-A'
    | 'OpenQual-B'
    | 'OpenQual-C'
    | 'ClosedQual-A1'
    | 'ClosedQual-A2'
    | 'ClosedQual-A3'
    | 'ClosedQual-B1'
    | 'ClosedQual-B2'
    | 'ClosedQual-B3'
    | 'ClosedQual-C1'
    | 'ClosedQual-C2'
    | 'ClosedQual-C3'
    | 'Final1'
    | 'ActivePlayers'
    | 'Partner'
    | 'Platinum';
  drawAmount: string;
  ticketsCount: number;
};
export type JackpotMetadataPrizeDto = {
  placesFrom: number;
  placesTo: number;
  money: number;
  jackpotTickets: JackpotMetadataTicketDto[];
};
export type JackpotMetadataDto = {
  drawAmount: string;
  ticketsCount: number;
  arePrizesByPercentageActive: boolean;
  prizes: JackpotMetadataPrizeDto[];
};
export type JackpotSlugWithMetadataDto = {
  jackpotSlug:
    | 'OpenQual-A'
    | 'OpenQual-B'
    | 'OpenQual-C'
    | 'ClosedQual-A1'
    | 'ClosedQual-A2'
    | 'ClosedQual-A3'
    | 'ClosedQual-B1'
    | 'ClosedQual-B2'
    | 'ClosedQual-B3'
    | 'ClosedQual-C1'
    | 'ClosedQual-C2'
    | 'ClosedQual-C3'
    | 'Final1'
    | 'ActivePlayers'
    | 'Partner'
    | 'Platinum';
  jackpotMetadata: JackpotMetadataDto;
};
export type JackpotsMetadataDto = {
  jackpotsMetadata: JackpotSlugWithMetadataDto[];
};
export type JackpotStatsRowDto = {
  slug: 'Final1';
  totalDrawnJackpotsCount: string;
  totalDrawnPrize: string;
  totalWinnersCount: string;
  jackpotMetadataPrizeAmount: string;
};
export type JackpotStatsDto = {
  rows: JackpotStatsRowDto[];
};
export type RequestTicketNumbersDto = {
  jackpotId: string;
  ticketIndices: string[];
};
export type JackpotWinInfo = {
  jackpotId: string;
  seeds: string[];
  winTickets: string[];
};
export type JackpotWinTicketIndicesDto = {
  ticketIndices: any[];
};
export type PlayersTopListRecordDto = {
  displayNumber: string | null;
  place: number | null;
  score: string;
};
export type PlayersTopListDto = {
  count: number;
  players: PlayersTopListRecordDto[];
  currentPlayer: PlayersTopListRecordDto;
};
export type JackpotReservesWithMetadataDto = {
  reserves: string;
  metadata: JackpotMetadataDto;
};
export type ReservesDto = {
  platinumJackpot: JackpotReservesWithMetadataDto;
  activePlayersJackpot: JackpotReservesWithMetadataDto;
  partnerJackpot: JackpotReservesWithMetadataDto;
};
export type PlatinumJackpotDrawTimeOutputDto = {
  time: string;
  msBeforeNextDraw: number;
};
export const {
  useJackpotControllerGetLatestDrawnJackpotsByUserIdQuery,
  useJackpotControllerGetLatestWinnersQuery,
  useJackpotControllerGetActiveJackpotsQuery,
  useJackpotControllerGetMyActiveJackpotsQuery,
  useJackpotControllerGetDrawnUserJackpotsQuery,
  useJackpotControllerGetUserWinsFromJackpotsQuery,
  useJackpotControllerGetJackpotHistoryQuery,
  useJackpotControllerGetJackpotWinnersQuery,
  useJackpotControllerGetJackpotMetadataQuery,
  useJackpotControllerGetJackpotsMetadataQuery,
  useJackpotControllerGetJackpotStatsQuery,
  useJackpotControllerGetMyWinTicketsQuery,
  useJackpotControllerGetJackpotWinInfoQuery,
  useJackpotControllerGetJackpotWinTicketIndicesQuery,
  useJackpotControllerGetUserTurnoverQuery,
  useJackpotControllerGetReservesQuery,
  useJackpotControllerGetDrawPlatinumJackpotTimeInUtcQuery,
  useHealthControllerPingQuery,
  useMetricsControllerGetMetricsQuery,
} = injectedRtkApi;
